import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ALL_PAYMENTS_STATUS } from "../../../helper/reportsHelper";


type PaymentsStatusFilterProps = {
  onChange: (value: string) => void;
  value?: string;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
export const PaymentsStatusFilter: React.FC<PaymentsStatusFilterProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();


  const paymentsStatusOptions = ALL_PAYMENTS_STATUS.map(
    (payment) => ({
      value: payment.code,
      label: payment.name,
    })
  );
  return (
    <SelectBoxWrapper>
      <Select
        mode="multiple"
        allowClear
        placeholder={t("payments.table.column.payment_status")}
        style={{ width: "100%", minWidth: 150 }}
        maxTagCount={1}
        options={paymentsStatusOptions}
        onChange={onChange}
        value={value}
      />
    </SelectBoxWrapper>
  );
};